import { createContext } from 'react';
import { IUserSchema } from '../../graphql/type/user';
import { ICurrencySchema } from '../../graphql/type/currency';
import { ICompanySchema } from '../../graphql/type/company';
import { IKeepitalSubscriptionPackageSchema } from '../../graphql/type/keepitalSubscriptionPackage';

export interface IContext {
  user: IUserSchema;
  isSuperAdmin: boolean;
  company: ICompanySchema;
  currencies: ICurrencySchema[];
  setCompany: (companyId: string) => void;
  companySubscriptionPackage: IKeepitalSubscriptionPackageSchema | null;
  refetchUserAndCompanyInfo: () => void;
}

const Context = createContext<IContext>({
  user: (null as unknown) as IUserSchema,
  isSuperAdmin: false,
  currencies: [],
  company: (null as unknown) as ICompanySchema,
  setCompany: (companyId) => {},
  companySubscriptionPackage: null,
  refetchUserAndCompanyInfo: () => {},
});

export default Context;
